import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { base_url } from '../admin/components/AdminUsers';

const Carousel = () => {

  const [banners, setBanners] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Initialize Bootstrap carousel when component mounts
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/js/bootstrap.bundle.min.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);


  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const response = await axios.get(`${base_url}/api/webapi/getAllBanner`);
        if (response.data.success) {
          const activeBanners = response.data.data.filter(banner =>
            banner.status === 'Active'
          );

          setBanners(activeBanners);
        } else {
          setError(response.data.message || "Failed to fetch banners");
        }
      } catch (err) {
        console.error("Error fetching banners:", err);
        setError("An error occurred while fetching banners.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchBanners();
  }, []);


  if (isLoading) {
    return <div className='slider-container'>Loading banners...</div>; // Or a spinner
  }

  if (error) {
    return <div className='slider-container'>Error: {error}</div>;
  }

  return (
    <div className="container-fluid p-0 m-0">
      {/* Import Bootstrap CSS */}
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/css/bootstrap.min.css"
      />

      <style>
        {`
          .carousel-item img {
            height: 451px;
            width: 1362px;
          }
          .carousel-item {
            transition: transform 0.1s ease-in-out !important;
          }
          .carousel-inner {
            scroll-behavior: smooth;
          }
          @media (max-width: 768px) {
            .carousel-item img {
             width: 100%;
             height: 155px;
            }
          }
        `}
      </style>

      <div className="">
        <div className="flex-grow-1">
          <div id="mainCarousel" className="carousel slide" data-bs-ride="carousel" data-bs-interval="3000">
            <div className="carousel-inner">
              {banners.map((item, index) => (
                <div key={index} className={`carousel-item ${index === 0 ? 'active' : ''}`}>
                  <img src={base_url + item.attachment} className="img-fluid d-block w-100" alt={item.title} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Carousel;